<div class="sat-admin-dialog">
  <h1 mat-dialog-title>Subscription Status</h1>
  <div mat-dialog-content class="message">
    <h3>
      This will permanently delete the subscription for
      <strong>{{ data.subscriptionIdentifier || 'this purchaser' }}</strong>.
      This action cannot be undone.
    </h3>
  </div>
  <div mat-dialog-actions class="actions">
    <button mat-stroked-button mat-dialog-close (click)="cancelDelete()">
      No - Go Back
    </button>
    <button color="warn" mat-raised-button mat-dialog-close (click)="confirmDelete()">
      Yes - Delete
    </button>
  </div>
</div>
